<template>
    <ErrorMessage :type="error?.statusCode === 404 ? 'notFound' : undefined" />
</template>

<script setup lang="ts">
    import type { NuxtError } from '#app'
    import ErrorMessage from '@/components/layout/ErrorMessage.vue'

    defineProps<{ error?: NuxtError }>()
</script>
